import { WHATSAPP_ORDER_PHONE, whatsappOrderUrl } from '@loop-coffee/commerce-contracts';

// Single source for contact data and purchase links, so swapping WhatsApp for the
// checkout (or changing a contact) touches one file instead of every section.

export const buyLink = whatsappOrderUrl('Olá! Vim pelo site da Loop Coffee e quero comprar o BitBean.');
export const talkLink = whatsappOrderUrl('Olá! Vim pelo site da Loop Coffee e queria tirar uma dúvida.');

export const contact = {
    phone: formatBrazilianPhone(WHATSAPP_ORDER_PHONE),
    email: 'oi@loopcoffee.com.br',
    emailHref: 'mailto:oi@loopcoffee.com.br',
    instagram: '@loopcoffee',
    instagramUrl: 'https://www.instagram.com/loopcoffee/',
    hours: 'Seg a sex, das 9h às 18h',
    city: 'Londrina (PR)',
};

export const sectionLinks = [
    { href: '#sobre', label: 'Sobre' },
    { href: '#bitbean', label: 'O BitBean' },
    { href: '#preparo', label: 'Como preparar' },
    { href: '#contato', label: 'Contato' },
];

// '5543991301093' -> '(43) 99130-1093'; derived so the label never drifts from the dialled number.
function formatBrazilianPhone(e164) {
    const local = String(e164).replace(/^55/, '');
    return `(${local.slice(0, 2)}) ${local.slice(2, local.length - 4)}-${local.slice(-4)}`;
}
